import { render, staticRenderFns } from "./VideoTrackConsumer.vue?vue&type=template&id=2d206c34&"
import script from "./VideoTrackConsumer.vue?vue&type=script&lang=js&"
export * from "./VideoTrackConsumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports